import * as React from 'react';
import { Authorization } from '../../misc/components/Authorization';
import Condition from '../../misc/components/Condition';
import { Permission, DcfRequestStatusEnum } from '../../misc/api/apiTypes';

export interface DataCorrectionApproveRejectProps {
    studyId: string;
    permissionId: string;
    permissions: Array<Permission>;
    currentRequestStatusId: string;
    requiredStatus: DcfRequestStatusEnum;
    isAuditModalVisible: boolean;
    title: string;
    children: React.ReactNode[];
}

export const DataCorrectionApproveReject = (props: DataCorrectionApproveRejectProps) => {
    return (
        <Authorization
            permissionId={props.permissionId}
            studyId={props.studyId}
            currentPermissions={props.permissions}
        >
            <Condition test={() => props.currentRequestStatusId === props.requiredStatus}>
                <h3 className="text-primary">{props.title}</h3>
                {props.children}
            </Condition>
        </Authorization>
    );
}
